"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = require("../..");
var _time = require("../../utils/time");
var _styles = _interopRequireWildcard(require("./styles"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const TimePicker = /*#__PURE__*/_react.default.forwardRef(({
  label,
  value,
  type = 'date',
  divider = _time.DEFAULT_DIVIDER,
  showSeconds = false,
  height = '36px',
  width,
  disabled = false,
  isNullable = false,
  css,
  validation,
  invalidMessage,
  autoFocus,
  onChange,
  onBlur
}, ref) => {
  // Static fields
  const _defaultNullableValue = showSeconds ? _time.DEFAULT_VALUE_FULL_NULLABLE : _time.DEFAULT_VALUE_SHORT_NULLABLE;
  const _defaultFilledValue = showSeconds ? _time.DEFAULT_VALUE_FULL : _time.DEFAULT_VALUE_SHORT;
  const _defaultValue = isNullable ? _defaultNullableValue : _defaultFilledValue;
  const _defaultWidth = width ? width : showSeconds ? '58px' : '35px';
  const _divider = divider && divider.length === 1 ? divider : _time.DEFAULT_DIVIDER;
  const _isDate = type === 'date';
  const removedNumberReplacer = isNullable ? '-' : '0';
  let valueToUse = isNullable && !value ? _defaultNullableValue : _isDate ? (0, _time.handleDateToStringConvertion)(value, showSeconds) : value;
  const [validatedTime] = (0, _time.validateTimeAndCursor)(showSeconds, valueToUse, _defaultValue, _divider, undefined, isNullable);
  const [inputStateValue, setInputStateValue] = (0, _react.useState)(validatedTime);

  // Loads of logic to handle string input with divider
  const onInputChange = async (event, callback) => {
    const _maxLength = _defaultValue.length;
    const inputValue = event.target.value;
    const position = event.target.selectionEnd || 0;
    const isTyped = inputValue.length > inputStateValue.length;
    const cursorCharacter = inputValue[position - 1];
    const addedCharacter = isTyped ? cursorCharacter : null;
    const removedCharacter = isTyped ? null : inputStateValue[position];
    const replacedSingleCharacter = inputValue.length === inputStateValue.length ? inputStateValue[position - 1] : null;
    let updatedValue = inputStateValue;
    let currentPosition = position;
    if (addedCharacter !== null) {
      if (position > _maxLength) {
        currentPosition = _maxLength;
      } else if ((position === 3 || position === 6) && addedCharacter === _divider) {
        updatedValue = `${inputValue.substring(0, position - 1)}${_divider}${inputValue.substring(position + 1)}`;
      } else if ((position === 3 || position === 6) && (0, _time.isNumber)(addedCharacter)) {
        updatedValue = `${inputValue.substring(0, position - 1)}${_divider}${addedCharacter}${inputValue.substring(position + 2)}`;
        currentPosition = position + 1;
      } else if ((0, _time.isNumber)(addedCharacter)) {
        // user typed a number
        updatedValue = inputValue.substring(0, position - 1) + addedCharacter + inputValue.substring(position + 1);
        if (position === 2 || position === 5) {
          /**
           * If the number has started out as --:--
           * On position 2, we want to replace the 2nd -- section with 00.
           */
          if (isNullable && updatedValue.endsWith('--') && !updatedValue.startsWith('--')) {
            updatedValue = updatedValue.replace('--', '00');
          }
          currentPosition = position + 1;
        }
      } else {
        // is input not a number, then keep old value & position
        currentPosition = position - 1;
      }
    }
    if (replacedSingleCharacter !== null) {
      // user replaced only a single character
      if ((0, _time.isNumber)(cursorCharacter)) {
        if (position - 1 === 2 || position - 1 === 5) {
          updatedValue = `${inputValue.substring(0, position - 1)}${_divider}${inputValue.substring(position)}`;
        } else {
          updatedValue = inputValue;
        }
      } else {
        // user replaced a number on some non-number character
        updatedValue = inputStateValue;
        currentPosition = position - 1;
      }
    } else if (typeof cursorCharacter !== 'undefined' && cursorCharacter !== _divider && !(0, _time.isNumber)(cursorCharacter)) {
      // set of characters replaced by non-number
      updatedValue = inputStateValue;
      currentPosition = position - 1;
    } else if (removedCharacter !== null) {
      if ((position === 2 || position === 5) && removedCharacter === _divider) {
        updatedValue = `${inputValue.substring(0, position - 1)}${removedNumberReplacer}${_divider}${inputValue.substring(position)}`;
        currentPosition = position - 1;
      } else {
        // user removed a number
        updatedValue = `${inputValue.substring(0, position)}${removedNumberReplacer}${inputValue.substring(position)}`;
      }
    }
    const [validatedTime, validatedCursorPosition] = (0, _time.validateTimeAndCursor)(showSeconds, updatedValue, inputStateValue, _divider, currentPosition, isNullable);

    // Needs to be awaited, for it to work
    await setInputStateValue(validatedTime);
    event.target.selectionStart = validatedCursorPosition;
    event.target.selectionEnd = validatedCursorPosition;
    const callbackValue = _isDate ? (0, _time.handleStringToDateConvertion)(validatedTime, value) : validatedTime;
    callback(callbackValue);
    event.persist();
  };

  // Select all on input focus
  const handleFocus = event => event.target.select();
  return (0, _jsxRuntime.jsxs)("label", {
    css: theme => [_styles.default.default(theme, height, _defaultWidth), validation && _styles.default.validation, invalidMessage && _styles.default.invalid(theme)],
    children: [label && (0, _jsxRuntime.jsx)(_styles.Label, {
      children: label
    }), (0, _jsxRuntime.jsx)("input", {
      "data-testid": "snorre-timepicker-input",
      type: "text",
      value: inputStateValue,
      disabled: disabled,
      autoFocus: autoFocus,
      ref: ref,
      css: theme => [css && css, disabled && _styles.default.disabled(theme), _styles.default.nullable],
      onChange: event => onInputChange(event, v => onChange?.(v)),
      onBlur: onBlur,
      onFocus: handleFocus
    }), invalidMessage && (0, _jsxRuntime.jsx)(_.IconErrorOutline, {
      size: "16px"
    }), invalidMessage && (0, _jsxRuntime.jsx)(_styles.ErrorMessage, {
      children: invalidMessage
    })]
  });
});
var _default = exports.default = TimePicker;